import {
  navigateTo,
  showError,
  createError,
} from 'nuxt/app';
import { defineStore } from 'pinia';
import { createClient, fetchExchange, mapExchange } from '@urql/core';
import { useIntakeAuthStore } from './useIntakeAuthStore';

const storeSetup = () => {
  const { accessToken, isAdvisor } = toRefs(useIntakeAuthStore());

  const gqlClient = createClient({
    url: import.meta.env.VITE_PROXY_URL ?? '',
    requestPolicy: 'network-only',
    fetchOptions: () => ({
      cache: 'no-cache',
      headers: {
        authorization: `Bearer ${accessToken?.value}`,
        role: isAdvisor.value ? 'advisor' : undefined,
        environment: import.meta.env.VITE_GRAPHQL_ENVIRONMENT,
      },
    }),
    exchanges: [
      mapExchange({
        onError(error) {
          if (
            error.message.includes('Unauthenticated') ||
            error.message.includes('missing two-factor authentication')
          ) {
            if (isAdvisor.value) {
              return navigateTo({ path: '/login' });
            }

            showError({
              statusCode: 401,
              statusMessage: 'Sessie verlopen',
            });

            // Fallback for history pushState (client-side navigation)
            if (process.client) {
              throw createError({
                statusCode: 401,
                statusMessage: 'Sessie verlopen',
              });
            }
          }
        },
      }),
      fetchExchange,
    ],
  });

  return {
    gqlClient,
  };
};

export const useUrqlStore = defineStore('intakeUrql', storeSetup, { persistedState: { persist: false } });
